/**
 * Synchronize notification polling across browser tabs
 * Only one tab polls, others listen via storage events
 */
class StorageSync {
  constructor(notificationService) {
    this.notificationService = notificationService;
    this.isLeader = false;
    this.tabId = `tab_${Date.now()}_${Math.random()}`;
    
    this.initializeLeaderElection();
  }

  initializeLeaderElection() {
    // Try to become leader
    this.becomeLeader();
    
    // Listen for storage changes from other tabs
    window.addEventListener('storage', (e) => {
      if (e.key === 'notification_last_check_time') {
        // Another tab just checked, so we don't need to poll
        const lastCheckTime = parseInt(e.newValue || 0);
        if (lastCheckTime > 0) {
          // Update our last check time so we don't duplicate
          this.notificationService.lastCheckTime = lastCheckTime;
        }
      }
    });
    
    // Re-check leader status periodically
    setInterval(() => {
      this.becomeLeader();
    }, 30000); // Every 30 seconds
  }

  becomeLeader() {
    const leaderTab = localStorage.getItem('notification_leader_tab');
    const leaderTime = parseInt(localStorage.getItem('notification_leader_time') || 0);
    const now = Date.now();

    // If no leader or leader is stale (more than 60 seconds old), become leader
    if (!leaderTab || (now - leaderTime > 60000)) {
      localStorage.setItem('notification_leader_tab', this.tabId);
      localStorage.setItem('notification_leader_time', String(now));
      this.isLeader = true;
      console.log('📱 Became notification polling leader');
    } else if (leaderTab === this.tabId) {
      // Refresh our leadership
      localStorage.setItem('notification_leader_time', String(now));
      this.isLeader = true;
    } else {
      this.isLeader = false;
    }
  }

  notifyOtherTabs(lastCheckTime) {
    // Tell other tabs we just checked notifications
    localStorage.setItem('notification_last_check_time', String(lastCheckTime));
  }

  shouldPoll() {
    // Only the leader tab should actively poll
    return this.isLeader;
  }
}

export default StorageSync;
